module.exports = __webpack_public_path__ + "static/media/play-button-white-small.1ecddcb5.svg";